import {
  GET_VENDOR_UPLOAD_REQUEST,
  GET_VENDOR_UPLOAD_SUCCESS,
  GET_VENDOR_UPLOAD_FAILURE,
  GET_VENDOR_DATA_FOR_DOWNLOAD_REQUEST,
  GET_VENDOR_DATA_FOR_DOWNLOAD_SUCCESS,
  GET_VENDOR_DATA_FOR_DOWNLOAD_FAILURE,
  UPLOADCSV_FOR_VENDOR_UPLOAD_REQUEST,
  UPLOADCSV_FOR_VENDOR_UPLOAD_SUCCESS,
  UPLOADCSV_FOR_VENDOR_UPLOAD_FAILURE,
} from "./vendorUploadTypes";
import axios from "axios";
import Config from "../../config/index";
let baseUrl = Config.baseUrl;

const getVendorUploadRequest = () => {
  return {
    type: GET_VENDOR_UPLOAD_REQUEST,
  };
};

const getVendorUploadSuccess = (payload) => {
  return {
    type: GET_VENDOR_UPLOAD_SUCCESS,
    payload: payload,
  };
};

const getVendorUploadFailure = (error) => {
  return {
    type: GET_VENDOR_UPLOAD_FAILURE,
    payload: error,
  };
};

const getVendorUpload = (
  userId,
  vendorCode,
  roleName,
  pageNo,
  rowsPerPage,
  search,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getVendorUploadRequest());
    let url;
    if (roleName === "vendor") {
      url = `${baseUrl}/vendor_stock/get?vendorId=${userId}&page_number=${
        pageNo + 1
      }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    } else {
      url = `${baseUrl}/vendor_stock/get_all?vendorCode=${vendorCode}&page_number=${
        pageNo + 1
      }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    }
    // let url = `${baseUrl}/v2/grn?page_number=3&rows_per_page=5&search=`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getVendorUploadSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getVendorUploadFailure(err.message));
      });
  };
};

const getVendorDataForDownloadRequest = () => {
  return {
    type: GET_VENDOR_DATA_FOR_DOWNLOAD_REQUEST,
  };
};

const getVendorDataForDownloadSuccess = (payload) => {
  return {
    type: GET_VENDOR_DATA_FOR_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const getVendorDataForDownloadFailure = (error) => {
  return {
    type: GET_VENDOR_DATA_FOR_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const getVendorDataForDownload = (userId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getVendorUploadRequest());

    let url = `${baseUrl}/vendor_stock/download_for_excel?vendorId=${userId}`;
    // let url = `${baseUrl}/v2/grn?page_number=3&rows_per_page=5&search=`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getVendorDataForDownloadSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getVendorDataForDownloadFailure(err.message));
      });
  };
};

const uploadCsvForVendorUploadRequest = () => {
  return {
    type: UPLOADCSV_FOR_VENDOR_UPLOAD_REQUEST,
  };
};

const uploadCsvForVendorUploadSuccess = (payload) => {
  return {
    type: UPLOADCSV_FOR_VENDOR_UPLOAD_SUCCESS,
    payload: payload,
  };
};

const uploadCsvForVendorUploadFailure = (error) => {
  return {
    type: UPLOADCSV_FOR_VENDOR_UPLOAD_FAILURE,
    payload: error,
  };
};

const uploadCsvForVendorUpload = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(uploadCsvForVendorUploadRequest());
    let url = `${baseUrl}/vendor_stock/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadCsvForVendorUploadSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadCsvForVendorUploadFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export { getVendorUpload, getVendorDataForDownload, uploadCsvForVendorUpload };
